'use client';

import { c as _c } from "react/compiler-runtime";
import { OnrampApiError } from '@morfi/onramp-sdk';
import { useEffect } from 'react';
import { logger } from '@/lib/telemetry/logger';
export function useFundingError(error) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== error) {
    t0 = () => {
      if (!error) {
        return;
      }
      logger.warn("onramp.history_failed", {
        code: error instanceof OnrampApiError ? error.code : "onramp_request_failed",
        ...(error instanceof OnrampApiError ? {
          requestId: error.requestId,
          status: error.status
        } : {})
      });
    };
    t1 = [error];
    $[0] = error;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}